<script setup lang="ts">
import AuthGate from '~/components/app/AuthGate.vue'
import NoticeGate from '~/components/app/NoticeGate.vue'
import OrgaBreadcrumb from '~/components/orga/OrgaBreadcrumb.vue'
import {
  ASYNC_OVERLAY_DELAY_MS,
  defineAsyncWithSkeleton,
} from '~/utils/defineAsyncWithSkeleton'

const AppLayoutBackToNationalLink = defineAsyncWithSkeleton(
  function loadAppLayoutBackToNationalLink() {
    return import('~/components/app/layout/AppLayoutBackToNationalLink.vue')
  },
)

const PrefsSplashScreen = defineAsyncWithSkeleton(
  function loadPrefsSplashScreen() {
    return import('~/components/app/PrefsSplashScreen.vue')
  },
  undefined,
  ASYNC_OVERLAY_DELAY_MS,
)

const WelcomeSplashScreen = defineAsyncWithSkeleton(
  function loadWelcomeSplashScreen() {
    return import('~/components/app/WelcomeSplashScreen.vue')
  },
  undefined,
  ASYNC_OVERLAY_DELAY_MS,
)

defineProps<{
  shouldUseAuthGate: boolean
  showBackToNationalView: boolean
  isLoadingPrefs: boolean
  shouldShowWelcomeSplash: boolean
  isWelcomeResolved: boolean
}>()

const emit = defineEmits<{
  welcomeSplashFinished: []
}>()

function onWelcomeSplashFinished(): void {
  emit('welcomeSplashFinished')
}
</script>

<template>
  <main>
    <div class="main-content">
      <template v-if="!shouldUseAuthGate">
        <AppLayoutBackToNationalLink v-if="showBackToNationalView" />
        <slot />
      </template>
      <AuthGate v-else>
        <NoticeGate>
          <PrefsSplashScreen v-if="isLoadingPrefs" />
          <WelcomeSplashScreen
            v-else-if="shouldShowWelcomeSplash"
            @finished="onWelcomeSplashFinished"
          />
          <template v-else-if="isWelcomeResolved">
            <AppLayoutBackToNationalLink v-if="showBackToNationalView" />
            <OrgaBreadcrumb />
            <slot />
          </template>
        </NoticeGate>
      </AuthGate>
    </div>
  </main>
</template>
